import * as React from 'react';
import { connectSortBy } from 'react-instantsearch-dom';
import wordpressData from 'data';
import SpriteIcon from 'search/components/sprite-icon';

interface CustomSortByDropdownState {
  opened: boolean;
}

interface CustomSortByDropdownPropsItem {
  label: string;
  value: string;
  isRefined: boolean;
}

interface CustomSortByDropdownProps {
  items: CustomSortByDropdownPropsItem[];
  currentRefinement: string;
  refine: (value: string) => void;
  createURL: (value: string) => string;
}

class CustomSortByDropdown extends React.Component<CustomSortByDropdownProps, CustomSortByDropdownState> {
  state: CustomSortByDropdownState = {
    opened: false,
  };

  private wrapperRef = React.createRef<HTMLDivElement>();

  constructor(props: CustomSortByDropdownProps) {
    super(props);

    // console.log('CustomSortByDropdown::constructor::props', props);

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside(event: MouseEvent) {
    if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target as Node)) {
      if (this.state.opened) {
        this.setState({ opened: false });
      }
    }
  }

  componentDidMount() {
    // console.log('CustomSortByDropdown::componentDidMount');
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    // console.log('CustomSortByDropdown::componentWillUnmount');
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    // console.log('CustomSortByDropdown::render');
    const { items, currentRefinement, refine, createURL } = this.props;
    const classes = ['c-dropdown-wrapper', this.state.opened ? 'has-dropdown-open' : ''];

    const currentItem = items.find((item) => item.value === currentRefinement) as CustomSortByDropdownPropsItem;

    return (
      <>
        <div className={classes.join(' ')} ref={this.wrapperRef}>
          <a
            href={wordpressData.productsUrl}
            className="c-tag c-tag--light c-tag--large c-dropdown-toggle"
            onClick={(event) => {
              event.preventDefault();
              this.setState({ opened: !this.state.opened });
            }}
          >
            <span className="c-dropdown-desc">Sort:</span>
            <span className="c-dropdown-value">{currentItem.label}</span>
          </a>
          <div className="c-dropdown c-dropdown--right">
            <div className="c-dropdown__header c-dropdown__header--sm">
              <span className="c-dropdown__title">Sort items by:</span>
              <span className="c-dropdown__toggle">
                <SpriteIcon name="close-thin" classes={['o-svg-icon']} />
              </span>
            </div>
            <div className="c-dropdown__body">
              <ul className="c-dropdown__list">
                {items.map((item) => (
                  <li key={item.value} className={item.isRefined ? 'is-selected' : ''}>
                    <a
                      href={createURL(item.value)}
                      onClick={(event) => {
                        event.preventDefault();
                        this.setState({ opened: false });
                        if (currentRefinement !== item.value) {
                          // console.log('item.value', item.value);
                          refine(item.value);
                        }
                      }}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const SortByDropdown = connectSortBy(CustomSortByDropdown);

export default SortByDropdown;
